import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import SelectAsync from "react-select/async";

import { bancos, formatCurrency, getCuentasForDropdown, money } from '../../../utils/helpers';
import PrefixedInput from '../../general/PrefixedInput';
import { METODOS_PAGO } from '../../../utils/types';
import { request } from '../../../utils/request';
import { auth } from '../../../utils/auth';

const PagoForm = ({
    pagoInfo,
    setPagoInfo,
    isEdit,
    setPorPagar,
    form,
    sumatoriaFinal,
    errores = {},
    condicionPago = () => {},
}) => {

    const [rawCuentas, setRawCuentas] = useState([]);
    const [cuentas, setCuentas] = useState([]);

    // Quien abre el modal lo pasa condicionado a que la factura tenga sumatoria
    // (`factura.sumatoria && {...}`), así que puede llegar vacío: sin totales el
    // formulario muestra ceros, que es mejor que tumbar la pantalla entera.
    const sumatoria = sumatoriaFinal || { impuestos: {}, total: 0 };

    const getCuentas = async () => {
        const response = await request('cuentas');
        return response.data;
    };

    const toOptions = (data) => data.map(c => ({label: c.nombre, value: c.id}));

    useEffect(() => {
        const cargarCuentas = async () => {
            const data = auth.manejaCuentas() && auth.cuentas().length > 0
                ? auth.cuentas()
                : await getCuentas();
            setRawCuentas(data);
            setCuentas(toOptions(data.filter(cuenta => auth.manejaCuentas() ? true : cuenta.tipo === 'LOCAL')));
        };
        cargarCuentas();
        setPagoInfo((state) => ({
            ...state,
            cuenta: auth.manejaCuentas() && auth.cuentas().length < 2 ? auth.cuentas()[0]?.id : "",
        }));
    }, []);

    useEffect(() => {
        const esLocal = !pagoInfo.tipo_pago || pagoInfo.tipo_pago === 'efectivo';
        const cuentas = rawCuentas.filter(cuenta => auth.esVendedor() ? true : (cuenta.tipo === 'LOCAL') === esLocal);
        setCuentas(toOptions(cuentas));
        setPagoInfo((state) => ({
            ...state,
            cuenta: auth.manejaCuentas() && cuentas.length < 2 ? cuentas[0]?.id : "",
        }));
    }, [pagoInfo.tipo_pago])

    console.log('pagoInfo', pagoInfo.tipo_pago);

    return (
        <>
            <div className="form-group">
                <label>Tipo de pago</label>
                <Select
					isClearable
					options={METODOS_PAGO}
					name="tipo_pago"
                    value={METODOS_PAGO.find(m => m.value === pagoInfo.tipo_pago) || null}
					onChange={(e) => {
                        setPagoInfo((state) => ({
                            ...state,
                            terminal_tarjeta: "",
                            tipo: "",
                            banco: "",
                            num_aprobacion: "",
                            num_cheque: "",
                            num_transferencia: "",
                            num_transaccion: "",
                            num_deposito: "",
                            tipo_pago: e?.value || "",
                        }));
                    }}
				/>
                {errores && errores['tipo_pago'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.tipo_pago[0]}
                    </small>
                )}
            </div>

            <div className="form-group">
                <label>Acreditar fondos a cuenta</label>
                <select
                    name="cuenta_destino"
                    className='form-control'
                    placeholder="Seleccionar..."
                    onChange={(e) => {
                        setPagoInfo((state) => ({
                            ...state,
                            cuenta: e.target.value,
                        }));
                    }}
                    value={pagoInfo.cuenta}
                >
                    <option value="">- Seleccionar -</option>
                    {cuentas.map(cuenta => (
                        <option value={cuenta.value}>{cuenta.label}</option>
                    ))}
                </select>
                <input
                    type="hidden"
                    name="cuenta"
                    value={pagoInfo.cuenta?.value}
                />
                {errores && errores['cuenta_destino'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.cuenta_destino[0]}
                    </small>
                )}
            </div>

            {pagoInfo.tipo_pago === "cheque" && (
                <ChequeInfoCobrar
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    errores={errores}
                />
            )}
            {pagoInfo.tipo_pago === "tarjeta-debito" && (
                <TarjetaInfo
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    errores={errores}
                />
            )}
            {pagoInfo.tipo_pago === "tarjeta" && (
                <TarjetaInfo
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    errores={errores}
                />
            )}
            {pagoInfo.tipo_pago === "transferencia" && (
                <TransferenciaInfo
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    errores={errores}
                />
            )}
            {pagoInfo.tipo_pago === "deposito" && (
                <DepositoInfo
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}
                    errores={errores}
                />
            )}
            {pagoInfo.tipo_pago === "otro" && (
                <OtroInfo
                    pagoInfo={pagoInfo}
                    setPagoInfo={setPagoInfo}

                />
            )}
            <div className="form-group">
                <label>Monto Recibido</label>
                <PrefixedInput
                    type="number"
                    prefix="RD$"
                    name="pago"
                    value={pagoInfo.pago}
                    setValue={(e) =>
                        setPagoInfo((state) => ({
                            ...state,
                            pago: e,
                        }))
                    }
                    onBlur={(e) => condicionPago(e)}
                />
                <input
                    type="hidden"
                    min="0"
                    className="form-control"
                    value={formatCurrency(pagoInfo.pago)}
                    onChange={(e) => {
                        e.persist();
                        setPagoInfo((state) => ({
                            ...state,
                            pago: e.target.value,
                        }));
                    }}
                />
                <input
                    type="hidden"
                    name="pago"
                    value={pagoInfo.pago}
                />
                <input
                    type="hidden"
                    name="monto"
                    value={pagoInfo.pago}
                />
            </div>
            <div
                className="row"
                style={{ justifyContent: "space-around" }}
            >
                <div
                    className="col-5 text-center"
                    style={{
                        border: "1px solid #cdd2d7",
                        borderRadius: "7px",
                        paddingTop: "8px",
                        paddingBottom: "8px",
                        cursor: "pointer",
                    }}
                    onClick={() => setPorPagar()}
                >
                    <h5 className="mb-2">Total Factura:</h5>
                    {isEdit ? (
                        <p>
                            {formatCurrency(
                                money(
                                    form.porCobrar -
                                        form.prevTotal +
                                        sumatoria.total
                                ) > 0
                                    ? money(
                                            form.porCobrar -
                                                form.prevTotal +
                                                sumatoria.total
                                    )
                                    : 0
                            )}
                        </p>
                    ) : (
                        <p>
                            {formatCurrency(
                                money(sumatoria.total)
                            )}
                        </p>
                    )}
                </div>
                <div
                    className="col-5 text-center"
                    style={{
                        border: "1px solid #cdd2d7",
                        borderRadius: "7px",
                        paddingTop: "8px",
                        paddingBottom: "8px",
                    }}
                >
                    <h5 className="mb-2">Devuelta:</h5>
                    <p>
                        {parseFloat(pagoInfo.pago) > parseFloat(sumatoria.total)
                            ? formatCurrency(
                                    money(
                                        pagoInfo.pago -
                                            sumatoria.total
                                    )
                            )
                            : 0}
                    </p>
                </div>
        </div>
        </>
    );
}

export default PagoForm;

export const TarjetaInfo = ({ pagoInfo, setPagoInfo, errores = {} }) => {
	return (
		<fieldset>
            <legend>Información de Tarjeta</legend>
			<div className="form-group">
				<label>Terminal de tarjeta</label>
				<input
					type="text"
					name="terminal_tarjeta"
					value={pagoInfo.terminal_tarjeta}
					onChange={(e) => {
						e.persist();
						setPagoInfo((state) => ({
							...state,
							terminal_tarjeta: e.target.value,
						}));
					}}
					className="form-control"
				/>
                {errores && errores['terminal_tarjeta'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.terminal_tarjeta[0]}
                    </small>
                )}
			</div>
			<div className="form-group">
				<label>Tipo</label>
                <Select
					options={[
                        {label: "Visa", value: "visa"},
                        {label: "Mastercard", value: "mastercard"},
                        {label: "Otro", value: "otro"},
                    ]}
					name="tipo"
					onChange={(e) => {
						setPagoInfo((state) => ({
							...state,
							tipo: e?.value ||"",
						}));
					}}
				/>
                {errores && errores['tipo'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.tipo[0]}
                    </small>
                )}
			</div>
			<div className="form-group">
				<label className="label form-control-label">
					Institución Financiera:
				</label>
				<Select
					isClearable
					options={bancos}
					name="banco"
					onChange={(e) => {
						setPagoInfo((state) => ({
							...state,
							banco: e?.value ||"",
						}));
					}}
				/>
                {errores && errores['banco'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.banco[0]}
                    </small>
                )}
			</div>
			<div className="form-group">
				<label>Numero de aprobación</label>
				<input
					type="text"
					className="form-control"
					name="num_aprobacion"
					value={pagoInfo.num_aprobacion}
					onChange={(e) => {
						e.persist();
						setPagoInfo((state) => ({
							...state,
							num_aprobacion: e.target.value,
						}));
					}}
				/>
                {errores && errores['num_aprobacion'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.num_aprobacion[0]}
                    </small>
                )}
			</div>
		</fieldset>
	);
};

// FacturacionRecurrente y los pagos cocurriculares lo usan sin estado propio
// (sin pagoInfo ni setPagoInfo): el input queda no controlado y el valor viaja en
// el formulario por su `name`.
export const ChequeInfoCobrar = ({ pagoInfo = {}, setPagoInfo = () => {}, errores = {} }) => {
	return (
        <fieldset>
            <legend>Información del Cheque</legend>
            <div className="form-group">
                <label>Número de cheque</label>
                <input
                    type="text"
                    name="num_cheque"
                    className="form-control"
                    value={pagoInfo.num_cheque}
                    onChange={(e) => {
                        e.persist();
                        setPagoInfo((state) => ({
                            ...state,
                            num_cheque: e.target.value,
                        }));
                    }}
                />
                {errores && errores['num_cheque'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.num_cheque[0]}
                    </small>
                )}
            </div>
            <div className="form-group">
                <label className="label form-control-label">
                    Institución Financiera:
                </label>
                <Select
                    isClearable
                    options={bancos}
                    name="banco"
                    onChange={(e) => {
                        setPagoInfo((state) => ({
                            ...state,
                            banco: e?.value,
                        }));
                    }}
                />
                {errores && errores['banco'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.banco[0]}
                    </small>
                )}
            </div>
        </fieldset>
	);
};

export const TransferenciaInfo = ({ pagoInfo, setPagoInfo, errores = {} }) => {
	return (
		<fieldset>
            <legend>Información de Transferencia</legend>
			<div className="form-group">
				<label>Numero de Transferencia</label>
				<input
					type="text"
					name="num_transferencia"
					className="form-control"
					value={pagoInfo.num_transferencia}
					onChange={(e) => {
						e.persist();
						setPagoInfo((state) => ({
							...state,
							num_transferencia: e.target.value,
						}));
					}}
				/>
                {errores && errores['num_transferencia'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.num_transferencia[0]}
                    </small>
                )}
			</div>
			<div className="form-group">
				<label className="label form-control-label">
					Institución Financiera:
				</label>
				<Select
					isClearable
					options={bancos}
					name="banco"
					onChange={(e) => {
						setPagoInfo((state) => ({
							...state,
							banco: e.value,
						}));
					}}
				/>
                {errores && errores['banco'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.banco[0]}
                    </small>
                )}
			</div>
		</fieldset>
	);
};

export const DepositoInfo = ({ pagoInfo, setPagoInfo, errores = {} }) => {
	return (
		<>
			<div className="form-group">
				<label>Numero de Deposito</label>
				<input
					type="text"
					name="num_deposito"
					className="form-control"
					value={pagoInfo.num_deposito}
					onChange={(e) => {
						e.persist();
						setPagoInfo((state) => ({
							...state,
							num_deposito: e.target.value,
						}));
					}}
				/>
                {errores && errores['num_deposito'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.num_deposito[0]}
                    </small>
                )}
			</div>
		</>
	);
};

export const OtroInfo = ({ pagoInfo, setPagoInfo, errores = {} }) => {
	return (
		<>
			<div className="form-group">
				<label>Numero de transaccion</label>
				<input
					type="text"
					name="num_transaccion"
					className="form-control"
					value={pagoInfo.num_transaccion}
					onChange={(e) => {
						e.persist();
						setPagoInfo((state) => ({
							...state,
							num_transaccion: e.target.value,
						}));
					}}
				/>
                {errores && errores['num_transaccion'] && (
                    <small className="help-blockParams form-Text">
                        {errores?.num_transaccion[0]}
                    </small>
                )}
			</div>
		</>
	);
};
